import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterMessage, getDefaultFilterMessage } from "../../../models/interfaces/IFilterMessage";
import { typeDemandeMessageListNotices, typeReponseMessageList, validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";
import CpntFilterButtons from "../../../components/CpntFilterButtons";
import CheckboxInput from "../../../components/forms/CheckBoxInput";


interface IProps {
  filter?: IFilterMessage;
  Notice? : boolean;
  changeFilter: (data: IFilterMessage) => void;
}


//Arrive pas a faire passer unb param au parent...
const MessagesNoticesFilter: React.FC<IProps> = ({ filter, changeFilter,Notice = true}) => {

  const prevFilterRef = useRef<IFilterMessage | undefined>(filter);
  const [selectedIdstypeDemandes, setSelectedIdstypeDemandes] = useState<any[]>([]);
  const [selectedIdstypeReponses, setSelectedIdstypeReponses] = useState<any[]>([]);
  useEffect(() => {

    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterMessage>({
    defaultValues: getDefaultFilterMessage(),
  });

  const { handleSubmit, reset, getValues } = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFilterMessagesNotices");
    setSelectedIdstypeDemandes([]);
    setSelectedIdstypeReponses([]);
    changeFilter(getDefaultFilterMessage());
    reset(getDefaultFilterMessage()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterMessage) => {
    const typeDemandes = selectedIdstypeDemandes.map((option: { value: any }) => option.value);
    const typeReponses = selectedIdstypeReponses.map((option: { value: any }) => option.value);
    const combinedData: IFilterMessage = {
      ...data,
      IdTypeDemandes: typeDemandes,
      IdTypereponses: typeReponses
    };
    changeFilter(combinedData);
    localStorage.setItem("IFilterMessagesNotices",JSON.stringify(combinedData)); //needed ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };
   useEffect(() => {
        if (filter?.IdTypeDemandes) {
          const SelectedIdstypeDemandesValues =typeDemandeMessageListNotices?.filter((typedemande: { Id: any }) =>
            filter?.IdTypeDemandes?.includes(typedemande.Id)
          ) || [];
          const SelectedIdstypeDemandesValuesList = SelectedIdstypeDemandesValues?.map((demande) => {
            return {
              label: demande.Libelle,
              value: demande.Id,
            };
          });
          setSelectedIdstypeDemandes(SelectedIdstypeDemandesValuesList);
        }
      }, [typeDemandeMessageListNotices]);
      useEffect(() => {
        if (filter?.IdTypereponses) {
          const SelectedIdsTypereponsesValues = typeReponseMessageList?.filter((typereponse: { Id: any }) =>
            filter?.IdTypereponses?.includes(typereponse.Id)
          ) || [];
          const SelectedIdsTypereponsesValuesList = SelectedIdsTypereponsesValues?.map((reponse) => {
            return {
              label: reponse.Libelle,
              value: reponse.Id,
            };
          });
          setSelectedIdstypeReponses(SelectedIdsTypereponsesValuesList);
        }
      }, [typeReponseMessageList]);
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[4, 4, 4]}>
            {Notice && (
              <CpntMultiSelect 
              DefaultLibelle="Sélectionner..."
              options={typeDemandeMessageListNotices?.map((tc) => {
                return {
                  Id: tc.Id,
                  Libelle: tc.Libelle,
                };
              })}
              value={selectedIdstypeDemandes}
              setSelected={setSelectedIdstypeDemandes}
              label="Type de mise à jour"
              ></CpntMultiSelect>
            )}
            <CpntMultiSelect 
            DefaultLibelle="Sélectionner..."
             options={typeReponseMessageList?.map((tc) => {
              return {
                Id: tc.Id,
                Libelle: tc.Libelle,
                //defaultChecked: civ.Id,
              };
            })}
              value={selectedIdstypeReponses}
              setSelected={setSelectedIdstypeReponses}
              label="Statut"
              ></CpntMultiSelect>            
            {Notice && (
              <TextInput
              label="Ean"
              formName="Ean"
              validationStyle={validationMode.none}
              placeholder="Ean"
              />
            )}
            <div></div>
            <CheckboxInput
                                      formName="MesdemandesFilter"
                                      label={`Filtrer sur mes demandes`}
                                      options={[
                                        {
                                          defaultChecked: false,
                                        },
                                      ]}
                                      labelRight={true}
                                    />
           <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default MessagesNoticesFilter;
